import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { UserService } from 'src/app/core/services/user.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { EmployeeRecord } from 'src/app/shared/models/EmployeeRecord.model';

@Component({
	selector: 'app-employee-record',
	templateUrl: './employee-record.component.html',
	styleUrls: ['../../../commandcenter.scss'],
})
export class EmployeeRecordComponent implements OnInit {
	employeeRecord: EmployeeRecord;

	constructor(
		public app: AppService,
		public venueService: OOVenueService,
		private focuslink: FocuslinkService,
		private router: Router,
		public userService: UserService,
		private activatedRoute: ActivatedRoute
	) {}

	ngOnInit(): void {
		this.app.loading(true);
		const employeeId = +this.activatedRoute.snapshot.paramMap.get('employeeId');
		this.getEmployee(employeeId);
	}

	async getEmployee(employeeId: number) {
		const resp = await this.focuslink.configsEmployeeOne(this.venueService.subscriptionVenue.value.key, employeeId);
		this.employeeRecord = new EmployeeRecord(resp);
		this.app.loading(false);
	}

	back() {
		this.router.navigate(['cc/employees/list']);
	}

	save() {}

	delete() {}
}
